

export const isLowMode = (): boolean => localStorage.getItem('low-mode') === 'yes';


export const isLowMode = (): boolean => localStorage.getItem('low-mode') === 'yes';
